import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Member } from '@modules/company-manager/clients/domain/entities/clients.entity';
import { API_ENDPOINTS } from '@typings/api-endpoints.type';
import { map, Observable, of } from 'rxjs';
import {
  GetCompaniesResponse,
  GetCompanyByIdResponse,
  UpdateCompanyResponse,
} from '../../domain/entities/company.entity';
import { CompanyServices } from '../../domain/services/company.service';
import { ApiQueryParams } from '@utils/api-query-params.type';
import { buildQueryParams } from '@utils/query';
import { AppUser } from '@modules/company-manager/users/domain';

@Injectable()
export class CompanyServicesImpl implements CompanyServices {
  constructor(private client: HttpClient) {}

  getAllCompanies(query: ApiQueryParams): Observable<any> {
    const params = buildQueryParams(query).set(
      'deepPopulate',
      `{"path":"subscription","populate":{"path":"invoices"}}`
    );

    return this.client
      .get<GetCompaniesResponse>(
        environment.apiDomain + API_ENDPOINTS.COMPANY.GET_ALL(),
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getCompanyById(companyId: string): Observable<GetCompanyByIdResponse> {
    const params = new HttpParams()
      .set('_id', companyId)

      .set(
        'deepPopulate',
        `[{"path":"members","populate":{"path":"requestsSentTotal"}},{"path":"members","populate":{"path":"requestsReceivedTotal"}},{"path":"subscription","populate":{"path":"plan"}}]`
      )
      .set('populate', 'subscription,settings');
    return this.client
      .get<GetCompaniesResponse>(
        environment.apiDomain + API_ENDPOINTS.COMPANY.GET_ALL(),
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  updateCompany(
    companyId: string,
    company: any
  ): Observable<UpdateCompanyResponse> {
    const params = new HttpParams().set('_id', companyId);
    return this.client
      .patch<UpdateCompanyResponse>(
        environment.apiDomain + API_ENDPOINTS.COMPANY.UPDATE(),
        company,
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  removeMember(memberId: any): Observable<Member> {
    const params = new HttpParams().set('_id', memberId);
    return this.client
      .delete<Member>(environment.apiDomain + API_ENDPOINTS.MEMBER.DELETE(), {
        params,
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getMemberById(memberId: any): Observable<AppUser> {
    const params = new HttpParams()
      .set('_id', memberId)
      .set('populate', 'profilePicture,company');
    return this.client
      .get<any>(
        environment.apiDomain + API_ENDPOINTS.USERS.PROFILE_DATA(memberId),
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  deleteCompany(companyId: string): Observable<any> {
    return this.client
      .delete<any>(
        environment.apiDomain + API_ENDPOINTS.COMPANY.DELETE(companyId)
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  sendInvoice(companyId: string): Observable<any> {
    return of({
      data: [
        {
          message: 'Success',
        },
      ],
    });
  }
  paymentHistory(companyId: string): Observable<any> {
    const params = new HttpParams().set(
      'deepPopulate',
      `{"path":"subscription","populate":{"path":"invoices"}}`
    );

    return this.client
      .get<any>(
        environment.apiDomain + API_ENDPOINTS.COMPANY.GET_BY_ID(companyId),
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  addCompany(company: any): Observable<any> {
    if (company.industry == '') delete company.industry;
    return this.client
      .post<any>(
        environment.apiDomain + API_ENDPOINTS.COMPANY.CREATE(),
        company
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getApproverByCompanyId(companyId: string): Observable<any> {
    const params = new HttpParams()
      .set('roles', 'approver')
      .set('_companyId', companyId);
    return this.client
      .get<any>(environment.apiDomain + API_ENDPOINTS.MEMBER.GET_ALL(), {
        params,
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  contactCompany(companyId: string): Observable<any> {
    return this.client
      .post<any>(
        environment.apiDomain + API_ENDPOINTS.COMPANY.CONTACT(companyId),
        {}
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  validateCompany(companyName: string): Observable<any> {
    return this.client
      .post<any>(
        environment.apiDomain + API_ENDPOINTS.COMPANY.VALIDATE_COMPANY(),
        {
          companyName: companyName,
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
